import { SET_DATA, SET_PAGINATION } from "./types";

const state = {
  data: [],
  pagination: {}
};

const mutations = {
  [SET_DATA](state, data) {
    state.data = data;
  },
  [SET_PAGINATION](state, pagination) {
    state.pagination = pagination;
  },
};

import * as getters from "./getters";
import * as actions from "./actions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
